import type { CargoAddressExtraData } from 'api/swagger';

interface ExtraResult {
  withLift: boolean;
  withBooking: boolean;
  withFixTime: boolean;
  withAttention: boolean;
}

export const parseAddressExtra = (extra?: CargoAddressExtraData[]): ExtraResult => {
  return {
    withLift: extra?.includes('truck_with_lift') || false,
    withBooking: extra?.includes('booking') || false,
    withFixTime: extra?.includes('fix_time') || false,
    withAttention: extra?.includes('attention') || false,
  };
};
